/**
 * Centralized route paths for Tasks & Notifications feature
 *
 * Single source of truth for all route constants, preventing hardcoded path
 * errors during refactoring and navigation changes.
 */

// Base path (matches app registry basePath)
export const BASE = '/tasks-and-notifications' as const;

/**
 * Absolute paths - use for navigate() and cross-app links
 * These include the full `/tasks-and-notifications` prefix
 */
export const PATHS = {
  // Base path
  BASE_PATH: BASE,

  // Main sections
  TASKS: `${BASE}/tasks`,
  NOTIFICATIONS: `${BASE}/notifications`,
  SETTINGS: `${BASE}/settings`,

  // Task detail (function to build path with ID)
  TASKS_DETAIL: (id: string | number) => `${BASE}/tasks/${id}`,
} as const;

/**
 * Relative paths - use within <Routes> and internal routing
 * These are relative to the parent route (no `/tasks-and-notifications` prefix)
 */
export const RELATIVE_PATHS = {
  // Root route (defaults to tasks)
  ROOT: '/',

  // Main sections (relative)
  TASKS: 'tasks',
  TASKS_DETAIL: 'tasks/:taskId',
  NOTIFICATIONS: 'notifications',
  SETTINGS: 'settings',

  // Fallback route
  FALLBACK: '*',
} as const;
